export default __webpack_public_path__ + "static/Surt-Regular-3970db04b01dd2a5b610c15f7fbb3c88.woff";